// od 1. 1. 2026 se nove sazby pouzivaji uz natvrdo primo v platba{oblast}.json
// pro vsechny oblasti krome 2 (F27.2 - registrace) a 14 (F27.8 - rocni udrzovaci
// platba) - u tech dvou formularu jeste zustava prepinac terminu podani zadosti
// (viz PaymentsKategorie), takze pro ne musi jit stare i nove sazby ziskat obe
export const changesOblast260101 = [2, 14]

export const CHANGES_FROM_260101 = 'od260101'
export const CHANGES_TO_251231 = 'do251231'

export const changesUhrada260101: any = {
  'R-001': 306460,
  'R-002': 251735,
  'R-003': 87560,
  'R-004': 120395,
  'R-007': 87560,
  'R-008': 6570,
  'R-040': 16420,
  'R-049': 109450,
  'R-009': 164175,
  'R-010': 38310,
  'R-011': 21890,
  'R-012': 4925,
  'R-013': 76615,
  'R-050': 16420,
  'R-015': 6680,
  'R-017': 306460,
  'R-017a': 415910,
  'R-018': 240790,
  'R-018a': 350240,
  'R-020': 120395,
  'R-021': 98505,
  'R-022': 125870,
  'R-023': 125870,
  'R-024': 27365,
  'R-025': 13135,
  'R-051': 153230,
  'R-026': 218900,
  'R-027': 136815,
  'R-028': 114925,
  'R-030': 49255,
  'R-031': 38310,
  'R-032': 60200,
  'R-033': 10945,
  'R-034': 4380,
  'R-052': 87560,
  'R-035': 87560,
  'R-036': 65670,
  'R-037': 27365,
  'R-038': 87560,
  'R-039': 32835,
  'R-041': 470635,
  'R-042': 372130,
  'R-044': 207955,
  'R-045': 153230,
  'R-048': 109450,
  'R-053': 5910,
  'U-001': 21345,
  'U-002': 42795,
  'U-003': 3285,
  'U-004': 5475,
  'U-005': 10400
}

export const changesText260101: Record<string, any> = {}

export const removePayments260101: string[] = []
